import { Experiment, Workspace } from "../../../types"
import { ExperimentListItem } from "./ExperimentListItem"

export type ExperimentListType = {
  experiments: Experiment[]
  workspace: Workspace
}

export const ExperimentList: React.FC<ExperimentListType> = ({ experiments, workspace }: ExperimentListType): React.ReactElement => {
  return (
    <>
      {
        experiments.map((experiment, index) => (
          <div key={experiment.id} className={`grid grid-cols-12 items-start gap-x-1 gap-y-0 py-[14px] ${index !== experiments.length - 1 ? 'border-b border-border-default' : ''}`}>
            <ExperimentListItem experiment={experiment} workspace={workspace} />
          </div>
        ))
      }
    </>
  )
}
